export default __webpack_public_path__ + "static/media/android-icon.c1267c35.svg";